import axios from "axios";
import { API_BASE_URL } from "./config/apiConfig";
import { applyFirebaseAuthHeaders } from "../../config/firebaseUser";

const planillasApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

planillasApi.interceptors.request.use(async (config) => {
  const nextConfig = await applyFirebaseAuthHeaders(config);
  // Garantiza que las rutas relativas usen el API (no el frontend en :3000/:3001)
  if (nextConfig.url && nextConfig.url.startsWith("/") && !nextConfig.baseURL) {
    nextConfig.baseURL = API_BASE_URL;
  }
  return nextConfig;
});

export { API_BASE_URL };
export default planillasApi;
